/**
 * Factory: Compute bytecode hash (keccak256)
 * @param {Object} deps - Crypto dependencies
 * @param {(data: Uint8Array) => Uint8Array} deps.keccak256 - Keccak256 hash function
 * @returns {(code: import('./BytecodeType.js').BrandedBytecode) => any} Function that computes bytecode hash
 */
export function Hash({ keccak256 }) {
	/**
	 * Compute bytecode hash (keccak256)
	 *
	 * @param {import('./BytecodeType.js').BrandedBytecode} code - Bytecode to hash
	 * @returns {any} Bytecode hash (32 bytes)
	 *
	 * @example
	 * ```typescript
	 * const code = new Uint8Array([0x60, 0x01]);
	 * const codeHash = hash(code);
	 * ```
	 */
	return function hash(code) {
		return keccak256(code);
	};
}
